module.exports = __webpack_public_path__ + "img/thailand.5baf21f0.svg";